import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";

import AccordionRows from "./AccordionRows";

export default function CourseTable({ courseData, checkboxHandler }) {
  const columns = React.useMemo(
    () => [
      {
        Header: ".",
        accessor: "checked",
        Cell: (props) => (
          <input
            type="checkbox"
            style={{ textAlign: "center" }}
            checked={props.value === true}
            onChange={(e, handleOriginal) => {
              //only trigger when checkbox value is toggled.
              props.original.checked = !props.original.checked;
              checkboxHandler(props);
            }}
          />
        ),
        maxWidth: 55,
        filterMethod: (filter, row) => {
          if (filter.value === "all") {
            return true;
          }
          if (filter.value === "true") {
            return row[filter.id] === true;
          }
          return row[filter.id] === false;
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">All</option>
            <option value="true">Checked</option>
            <option value="false">Unchecked</option>
          </select>
        ),
      },
      {
        Header: "ID",
        accessor: "courseId",
        maxWidth: 100,
      },
      {
        Header: "Name",
        accessor: "name",
        minWidth: 100,
      },
      {
        Header: "Professor(s)",
        accessor: "lecturersNames",
      },
      {
        Header: "Type",
        accessor: "category",
      },
      {
        Header: "Block",
        accessor: "isBlockCourse",
        Cell: (props) => (
          <div>
            {" "}
            {props.value ? <span> Block </span> : <span> Regular </span>}
          </div>
        ),
        maxWidth: 75,
        filterMethod: (filter, row) => {
          if (filter.value === "all") {
            return true;
          } else if (filter.value === "true") {
            return row[filter.id] === true;
          } else {
            return row[filter.id] === false;
          }
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">All</option>
            <option value="true">Block</option>
            <option value="false">Regular</option>
          </select>
        ),
      },
      {
        Header: "Exam",
        accessor: "examType",
        maxWidth: 75,
        filterMethod: (filter, row) => {
          // change to switch case???
          if (filter.value === "" || filter.value === "all") {
            return true;
          }
          if (filter.value === "Zentral & Dezentral") {
            return row[filter.id] === "Zentral & Dezentral";
          }
          if (filter.value === "Zentral") {
            return row[filter.id] === "Zentral";
          }
          return row[filter.id] === "Dezentral";
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">Alle</option>
            <option value="Zentral & Dezentral">Zentral & Dezentral</option>
            <option value="Zentral">Zentral</option>
            <option value="Dezentral">Dezentral</option>
          </select>
        ),
      },
      {
        Header: "ECTS",
        accessor: "credits",
        maxWidth: 60,
        filterMethod: (filter, row) => {
          var numAr = filter.value.split(",");
          return row.credits !== undefined
            ? numAr.indexOf(String(row.credits)) > -1
            : true;
        },
        Filter: ({ filter, onChange }) => (
          <input
            type="text"
            placeholder="2,4,6"
            onChange={(event) => onChange(event.target.value)}
          />
        ),
      },
      {
        Header: "Lang",
        accessor: "lang",
        maxWidth: 50,
        filterMethod: (filter, row) => {
          if (filter.value === "all") {
            return true;
          }
          if (filter.value === "de") {
            return row[filter.id] === "de";
          }
          return row[filter.id] === "en";
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">Alle</option>
            <option value="de">DE</option>
            <option value="en">EN</option>
          </select>
        ),
      },
    ],
    [checkboxHandler]
  );

  return (
    <ReactTable
      className={"-highlight -striped"}
      data={courseData}
      filterable={true}
      showFilters={true}
      defaultFilterMethod={filterCaseInsensitive}
      columns={columns}
      pageSize={courseData.length}
      showPaginationBottom={false}
      showPageSizeOptions={false}
      SubComponent={(row) => {
        return <AccordionRows data-courseInfo={row.original} />;
      }}
    />
  );
}

const filterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id;
  if (row[id] !== null) {
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  }
};
